import { arrayFilterNullable } from 'utils/filterNullable/index'

import type { JackpotsApiResponse, ProviderJackpot, ProviderJackpotResponse } from '../types'

function transformJackpotResponse(jackpot: ProviderJackpotResponse): ProviderJackpot {
  return {
    ...jackpot,
    amount: Number(jackpot.amount),
  }
}

type FetchLike = (url: string, body: unknown, options?: unknown) => Promise<{ json: () => Promise<unknown> }>

export async function getJackpots(apiUrl: string, fetchFn: FetchLike): Promise<ProviderJackpot[]> {
  try {
    const response = await fetchFn(apiUrl, null, { method: 'get' })
    const result = (await response.json()) as JackpotsApiResponse

    const jackpots = arrayFilterNullable(result?.jackpots)

    return jackpots.map(transformJackpotResponse)
  } catch (error: unknown) {
    console.error('Fetch getJackpots function error: ', 'URL', apiUrl, 'Error', (error as Error)?.message)

    return []
  }
}
